<script setup lang="ts">
import { TableEntityChangelog, ModalChangelogDetail } from '@widgets/changelog'

import { useDisciplineChangelog } from '../model/discipline-changelog.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'

defineOptions({
  name: 'DisciplineChangelogPage',
})

const { refIsFirstLoad } = useDisciplineChangelog()
</script>

<template>
  <DisciplinePageLoader :loading="refIsFirstLoad" />
  <TableEntityChangelog />
  <ModalChangelogDetail />
</template>
